import React from "react";
import PropTypes from 'prop-types';
import { TextField, useFormValidation } from "../../index";

export const EmailAddressWithValidation = ({
    customValidation,
    errorMsg = "Enter a valid email address",
    hintMsg,
    name,
    onBlur = () => { },
    onChange = () => { },
    onClick,
    pattern,
    required = false,
    ...props
}) => {
    const emailAddressPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;    //basic email regex

    const validationRules = {
        [name]: {
            required: {
                value: required,
                message: errorMsg
            },
            pattern: {
                value: pattern ? pattern : emailAddressPattern,
                message: errorMsg
            },
            custom: {
                isValid: customValidation,
                message: errorMsg
            }
        }
    };

    const { handleInput, formErrors } = useFormValidation({ validations: validationRules });

    const handleChange = (event) => {
        const value = event.target.value;
        handleInput(event);

        onChange(event, value, formErrors[name]?.value);
    }

    const handleBlur = (event) => {
        const value = event.target.value;
        handleInput(event);

        onBlur(event, value, formErrors[name]?.value);
    }

    return (
        <TextField
            {...props}
            error={formErrors[name]?.value}
            hintMsg={formErrors[name]?.message ? formErrors[name]?.message : hintMsg}
            name={name}
            onBlur={handleBlur}
            onChange={handleChange}
            required={required}
            onClick={onClick}
        />
    )
}

EmailAddressWithValidation.propTypes = {
    customValidation: PropTypes.func,
    errorMsg: PropTypes.string,
    hintMsg: PropTypes.string,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    pattern: PropTypes.string,
    required: PropTypes.bool,
}